import { EventEmitter } from './helpers/EventEmitter';

export const emitter = new EventEmitter();
